import type { KeyboardEvent } from 'react';

export const blockInvalidNumberChar = (e: KeyboardEvent<HTMLInputElement>) => {
  const { key } = e;

  if (['e', 'E', '+'].includes(key)) {
    e.preventDefault();
  }
};

export const blockInvalidNumberCharIncludingNegative = (
  e: KeyboardEvent<HTMLInputElement>
) => {
  const { key } = e;

  if (['e', 'E', '+', '-'].includes(key)) {
    e.preventDefault();
  }
};

export const formatPhoneNumber = (value: string): string => {
  // Return empty string if value is empty or just a plus sign
  if (!value || value === '+') {
    return '';
  }

  // Remove "+" and keep digits after "1"
  const numericValue = (value.startsWith('+1') ? value : `+1${value}`)
    .replace(/[^\d]/g, '')
    .slice(1);

  // Return only "+1" if no digits are entered
  if (!numericValue) {
    return '+1';
  }

  // Format area code
  if (numericValue.length <= 3) {
    return `+1 (${numericValue}`;
  }

  // Format area code and prefix
  if (numericValue.length <= 6) {
    return `+1 (${numericValue.slice(0, 3)}) ${numericValue.slice(3)}`;
  }

  // Format full phone number
  return `+1 (${numericValue.slice(0, 3)}) ${numericValue.slice(3, 6)}-${numericValue.slice(6, 10)}`;
};
